import { ActionReducerMap } from '@ngrx/store';

import { configureCleanReducer, configureSyncReducer, TileAction, TileId } from '@contact/upgrade';

/**
 * Name store feature
 */
export const featureName = 'history';

/**
 * History state interface
 */
export interface HistoryState {}

/**
 * Initial History state
 */
export const initialState: HistoryState = {};

/**
 * History reducers map
 */
export const reducers: ActionReducerMap<HistoryState> = {};

const cleanReducer = configureCleanReducer(featureName, {
  initialState,
  keys: [],
  cleanPredicate: action => action.type === TileAction.Reset.type && action.tileId === TileId.HISTORIZATION,
});
const syncReducer = configureSyncReducer(featureName, []);

/**
 * Core meta reducers array
 */
export const metaReducers = [cleanReducer, syncReducer];
